export default __webpack_public_path__ + "static/media/blunderbuss_alone.225065eb.png";